import { t, Trans } from '@lingui/macro';
import { Box, Button } from '@material-ui/core';
import { OpenInNew } from '@material-ui/icons';

import FormSection from '../../form/FormSection';
import { AdminPages } from '../AdminLinkUtils';
import AgentReadOnlyVoip from './AgentReadOnlyVoip';
import Link from '../../links/Link';

export default function VoipAgentReadOnlySection({ agent, recordId }) {
    return (
        <FormSection title={<Trans>nPoint Details</Trans>}>
            <AgentReadOnlyVoip agent={agent} />
            <Box mt={2}>
                <Button component={Link} to={`/admin/${AdminPages.Agents}/${recordId}`} endIcon={<OpenInNew />}>
                    <span>{t`NPOINT CONFIGURATION`}</span>
                </Button>
            </Box>
        </FormSection>
    );
}
